import apiClient from "../core/HttpClient";
import HttpClient from "../core/HttpClient";
import { PaginationResult } from "../lib/definitions";
import { User } from "../models";
 
export default class UsersService {
  // Define methods for user-related operations
  async getUsers(page: number, pageSize: number, query: string) {
    return apiClient
      .get<PaginationResult<User>>("/users", {
        params: {
          page: page,
          pageSize: pageSize,
          query: query,
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  async getUserById(userId: any) {
    // Logic to fetch users
    return apiClient.get(`/users/${userId}`).then((response) => {
      return response.data;
    });
  }

  async createUser(userData: any) {
    // Logic to create a new user
  }

  async updateUser(userId: any, userData: any) {
    // Logic to update an existing user
    return apiClient.put(`/users/${userId}`, userData)
    ;
  }
  async updateMyProfile(userData: any) {
    return apiClient.put("/Users/profile", userData);  
  }
  async uploadUserProfile(file: File){
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.post("/Users/profile-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    
  }
    // Logic to update an existing user
  async deleteUser(userId: any) {
    // Logic to delete a user
  }
  async getMyProfile() {
    // Logic to get the current user's profile
    return apiClient.get("/Users/profile");
  }
}
